import { BtnClasses, IconButton } from '@tcweb/connect-ui';
// eslint-disable-next-line custom/no-modus-v1 -- TWENG-132
import { ModusTextInputCustomEvent } from '@trimble-oss/modus-web-components/loader';
import { t } from '@trimble/i18n';
import { Accessor, JSX } from 'solid-js';

export interface PanelHeaderSearchInputProps {
  filterString: Accessor<string>;
  setFilterString(value: string): void;
  setIsSearchOpen(value: boolean): void;
  placeHolderText?: string;
  onClick?(): void;
}

export const PanelHeaderSearchInput = (
  props: PanelHeaderSearchInputProps
): JSX.Element => {
  return (
    <div class="flex items-center justify-between w-full gap-2">
      <i class="icon-font tc-icon-search text-gray-6" />
      {/* eslint-disable-next-line custom/no-modus-v1 -- TWENG-132 */}
      <modus-text-input
        class="flex-1"
        placeholder={props.placeHolderText || t('general.search')}
        input-mode={'search'}
        type={'search'}
        include-search-icon={false}
        value={props.filterString()}
        on:valueChange={(event: ModusTextInputCustomEvent<string>) => {
          props.setFilterString(event.detail ?? '');
        }}
        clearable
        onClick={() => props.onClick?.()}
      />
      <IconButton
        color={BtnClasses.TERTIARY}
        icon="tc-icon-content-close"
        size="icon-medium"
        clicked={() => {
          props.setIsSearchOpen(false);
          props.setFilterString('');
        }}
      />
    </div>
  );
};
